/* eslint-disable */

const region = 'us-central1';

const local = `http://localhost:5000/ps-dev-environment/${region}`;

const dev = `https://${region}-ps-dev-environment.cloudfunctions.net`;
const prod = 'https://us-central1-personalised-surgery.cloudfunctions.net';

const apiUrl = prod;

export default apiUrl;
